import type { HouseDetailsAttributes, Locale } from 'lc-services/types'

export const useHouseStructuredData = () => {
  const { locale, tm, rt } = useI18n({ useScope: 'global' })
  const { getBaseURL } = useURL()

  const breadcrumbStructuredData = (
    destination: HouseDetailsAttributes['destination'],
  ) => {
    const destinationF = []
    const baseURL = `${getBaseURL()}/${locale.value}`

    if (destination?.name) {
      const slug = destination.destinationUrl?.[locale.value as Locale]
      const url = `${baseURL}/${slug}`

      destinationF.push({
        name: destination.name,
        url,
      })
    }
    if (destination?.cluster?.name) {
      const slug = destination.cluster.searchUrl[locale.value as Locale]
      const url = `${baseURL}/${slug}`

      destinationF.push({
        name: destination.cluster.name,
        url,
      })
    }

    if (destination?.country?.name) {
      const slug = destination.country.searchUrl[locale.value as Locale]
      const url = `${baseURL}/${slug}`

      destinationF.push({
        name: destination.country.name,
        url,
      })
    }

    const itemListElement = destinationF.map((d, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        name: d.name,
        item: d.url,
      }
    })

    return {
      '@type': 'BreadcrumbList',
      itemListElement,
    }
  }

  const faqStructuredData = () => {
    const sections = tm('house.bookingConditions.sections') as unknown as {
      question: string
      answer: string[]
    }[]
    return Array.isArray(sections)
      ? {
          '@type': 'FAQPage',
          mainEntity: sections.map((section) => ({
            '@type': 'Question',
            name: rt(section.question),
            acceptedAnswer: {
              '@type': 'Answer',
              text: section.answer.map(rt).join('\n\n'),
            },
          })),
        }
      : {}
  }

  return { breadcrumbStructuredData, faqStructuredData }
}
